import React from "react";
import * as dayjs from "dayjs";
import styles from "./index.module.scss";
import Image from "next/image";

export default function Article(props) {
  const {
    title = "",
    image = null,
    color = null,
    description = "",
    author = "",
    avatar = "",
    created = "",
    readingTime = null,
  } = props;
  return (
    <div className={styles.container}>
      <div
        className={styles.image}
        style={{ backgroundColor: color ? color : "initial" }}
      >
        {image && (
          <div className={styles.imgWrap}>
            <Image
              src={image}
              loader={() => image}
              layout="fill"
              loading="lazy"
            />
          </div>
        )}
        {readingTime > 0 && (
          <div className={styles.readingTime}>{readingTime} min read</div>
        )}
      </div>
      <div className={styles.meta}>
        <div className={styles.author}>
          <div className={styles.avatar}>
            <Image
              src={avatar}
              loader={() => avatar}
              width="24"
              height="24"
              loading="lazy"
              alt={author}
            />
          </div>
          {author}
        </div>
        <div className={styles.date}>
          {dayjs(created).format("MMMM DD, YYYY")}
        </div>
      </div>
      <div className={styles.content}>
        <h2 className={styles.title}>{title.trim()}</h2>
        <div
          className={styles.description}
          dangerouslySetInnerHTML={{ __html: description }}
        />
      </div>
    </div>
  );
}
